import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SplashScreen } from 'src/components/loading-screen';
import LandingLayout from 'src/LandingUi/LandingLayout';
import BookDemoPage from '../../LandingUi/registerUi/BookDemoPage';

const RegisterPage = lazy(() => import('src/LandingUi/registerUi/RegisterPage'));

export const onboardRoutes = [
    {
        path: '/', // 👈 your custom name
        element: (
            <Suspense fallback={<SplashScreen />}>
                <Outlet />
            </Suspense>
        ),
        children: [
            {
                path: 'onboard',
                element: <RegisterPage />,
            },
            {
                path: 'book-demo',
                element: <BookDemoPage />,
            },
        ],
    },
];